import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { DebugShellComponent } from './app/debug/debug-shell.component';

// The local demo runs inside the debug wrapper (persona switch + mock phone + HTTP/bank logs). The
// wrapper renders the real <tb-root> once a persona is locked in.
bootstrapApplication(DebugShellComponent, appConfig).catch((err) => console.error(err));
